/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest =
  {
    ledgerCanisterId: string;
  };

/** @internal */
export const GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$inboundSchema:
  z.ZodType<
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$outboundSchema:
  z.ZodType<
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$Outbound,
    z.ZodTypeDef,
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$ {
  /** @deprecated use `GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$inboundSchema;
  /** @deprecated use `GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$outboundSchema;
  /** @deprecated use `GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$Outbound` instead. */
  export type Outbound =
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$Outbound;
}

export function getLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequestToJSON(
  getLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest:
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest,
): string {
  return JSON.stringify(
    GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$outboundSchema
      .parse(
        getLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest,
      ),
  );
}

export function getLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetLedgerTransactionsImageApiV1ImagesLedgersLedgerCanisterIdTransactionsPngGetRequest' from JSON`,
  );
}
